import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from '../../css/components/password-forgotten/passwordForgotten.css';
import TextInput, { TEXT_INPUT_STYLES } from '../forms/TextInput';
import CTAButton from '../buttons/CTAButton';
import ErrorMessage, { ERROR_MESSAGE_STYLES } from '../forms/ErrorMessage';
import { isEmpty, isTooShort } from '../../helpers/password-forgotten/common';

function SsoSetPasswordForm({ onCtaButtonPressCallback }) {
	const { t } = useTranslation('translation');

	const [password1Value, setPassword1Value] = useState('');
	const [isErrorMessage1Shown, setIsErrorMessage1Shown] = useState(false);
	const [password1ErrorMessage, setPassword1ErrorMessage] = useState('');
	const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);

	const showError = () => {
		setIsErrorMessage1Shown(true);
	};

	const pwTooShortError = t('passwordForgotten.changePassword.errorMessages.errorMessageTooShort');
	const pw1EmptyError = t('passwordForgotten.changePassword.errorMessages.errorMessageInput1Empty');

	function validateFrontend() {
		if (isTooShort(password1Value)) {
			setPassword1ErrorMessage(pwTooShortError);
			showError();
			setShowLoadingIndicator(false);

			return false;
		}
		else if (isEmpty(password1Value)) {
			setPassword1ErrorMessage(pw1EmptyError);
			showError();
			setShowLoadingIndicator(false);

			return false;
		}

		return true;
	}

	return (
		<form
			className={styles.passwordForgottenWrapper}
			onKeyDown={(e) => {
				if (e.key === 'Enter') {
					e.preventDefault();
					setShowLoadingIndicator(true);
					validateFrontend() && onCtaButtonPressCallback(password1Value);
				}
			}}
		>
			<fieldset>
				<TextInput
					type="password"
					id="pop-up_pw-forgotten_new-password_input_password-1"
					labelText={t('passwordForgotten.changePassword.input1Label')}
					value={password1Value}
					onChangeCallback={(e) => setPassword1Value(e.target.value)}
					style={TEXT_INPUT_STYLES.PASSWORD_FORGOTTEN}
					disabled={showLoadingIndicator}
				/>
				{isErrorMessage1Shown &&
					<ErrorMessage
						text={password1ErrorMessage}
						style={ERROR_MESSAGE_STYLES.PASSWORD_FORGOTTEN}
					/>
				}
			</fieldset>
			<CTAButton
				buttonLabel={t('be.api.sso.buttonLabel')}
				onButtonClick={() => {
					setShowLoadingIndicator(true);
					validateFrontend() && onCtaButtonPressCallback(password1Value);
				}}
				buttonId="pop-up_pw-forgotten_new-password_button_change-password"
				extraClassName={'passwordForgotten'}
				isDisabled={showLoadingIndicator}
			/>
		</form>
	);
}

SsoSetPasswordForm.propTypes = {
	onCtaButtonPressCallback: PropTypes.func.isRequired,
};

export default SsoSetPasswordForm;
